import { KycProps } from '../../../constants/kyc';
import type {
  FormInputControl,
  KycSettlementInfoType,
  FormBankControl,
  FormSelectControl,
  FormTooltipControl,
  KycSettlementInfoControlType,
} from 'src/types/form-config';

import { getFormDataLimit } from '../../../utils';

const mobileNumber: FormInputControl = {
  tag: 'input',
  placeholder: 'mobile number',
  name: KycProps.MOBILE_NUMBER,
  type: 'text',
  label: 'Mobile Number',
  validator: 'required=true, mobile=true',
};

const bank: FormBankControl = {
  tag: 'bank',
  controls: {
    bank: {
      tag: 'select',
      placeholder: 'bank name',
      name: KycProps.BANK,
      type: 'text',
      label: 'Bank Name',
      options: [],
      validator: 'required=true',
      remoteOption: true,
      optionCategory: 'BANK',
      optionGetter: 'getOptionsBank',
    } as FormSelectControl,

    branch: {
      tag: 'select',
      placeholder: 'branch name',
      name: KycProps.BANK_BRANCH_ID,
      type: 'text',
      label: 'Branch Name',
      options: [],
      validator: 'required=true',
      remoteOption: true,
      optionCategory: 'BRANCH',
      optionGetter: 'getOptionsBank',
    } as FormSelectControl,
  },
};

const accountNo: FormInputControl = {
  tag: 'input',
  placeholder: 'account number',
  name: KycProps.ACCOUNT_NUMBER,
  type: 'text',
  label: 'Account Number',
  validator: 'required=true, min=2, max=20',
};

const accountName: FormInputControl = {
  tag: 'input',
  placeholder: 'account name',
  name: KycProps.ACCOUNT_NAME,
  type: 'text',
  label: 'Account Name | (Should be the same with your bank records)',
  validator: 'required=true, min=2, max=50',
};

const typeOfAccount: FormSelectControl = {
  tag: 'select',
  placeholder: 'type of account',
  name: KycProps.ACCOUNT_TYPE,
  type: 'text',
  label: 'Account Type',
  options: [],
  optionCategory: 'TYPE_OF_ACCOUNT',
  optionGetter: 'getOptions',
  validator: 'required=true',
  remoteOption: true,
};

const tooltip: FormTooltipControl = {
  tag: 'tooltip',
  text: 'All redemptions/proceeds will be deposited directly to your settlement account ',
};

const controls: KycSettlementInfoControlType = [
  mobileNumber,
  bank,
  accountNo,
  accountName,
  typeOfAccount,
  tooltip,
];

const KycSettlementInfoData: KycSettlementInfoType = {
  name: 'settlement_info',
  display: 'Settlement Info',
  controls,
  getFormData: getFormDataLimit(controls),
};

export default KycSettlementInfoData;
